(function () {
  if (typeof window === 'undefined') return;

  const LIMIT = 4;
  const ENDPOINT = '/recommendations/products.json';

  let lastSeedId = null;
  let isRunning = false;

  function moneyDk(cents) {
    const kr = (cents / 100);
    const hasOre = kr % 1 !== 0;
    return hasOre
      ? kr.toFixed(2).replace('.', ',') + ' kr'
      : Math.round(kr) + ' kr';
  }

  function buildItem(product) {
    const variant = product.variants.find(v => v.available) || product.variants[0];
    if (!variant) return '';
    const img = product.featured_image
      ? product.featured_image.replace(/(\.(jpe?g|png|webp))(\?.*)?$/i, '_120x$1$3')
      : '';
    const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
    const variantLabel = (variant.title && variant.title !== 'Default Title') ? variant.title : '';
    const priceHTML = onSale
      ? `<span class="cart-drawer-upsell__price-now">${moneyDk(variant.price)}</span><span class="cart-drawer-upsell__price-was">${moneyDk(variant.compare_at_price)}</span>`
      : moneyDk(variant.price);
    const priceClass = onSale
      ? 'cart-drawer-upsell__price cart-drawer-upsell__price--on-sale'
      : 'cart-drawer-upsell__price';

    return `
      <li class="cart-drawer-upsell__item">
        <a href="/products/${product.handle}" class="cart-drawer-upsell__link">
          ${img ? `<img src="https:${img}" loading="lazy" class="cart-drawer-upsell__thumb" alt="${product.title.replace(/"/g, '&quot;')}">` : ''}
          <span class="cart-drawer-upsell__body">
            <span class="cart-drawer-upsell__title">${product.title}</span>
            ${variantLabel ? `<span class="cart-drawer-upsell__variant">${variantLabel}</span>` : ''}
            <span class="${priceClass}">${priceHTML}</span>
          </span>
        </a>
        ${variant.available ? `
          <button
            type="button"
            class="cart-drawer-upsell__add"
            data-quick-add
            data-variant-id="${variant.id}"
            aria-label="Tilføj ${product.title.replace(/"/g, '&quot;')} til kurv">
            <svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M12 5v14M5 12h14"/>
            </svg>
          </button>
        ` : ''}
      </li>
    `;
  }

  async function refresh() {
    if (isRunning) return;
    isRunning = true;
    try {
      const cartRes = await fetch('/cart.js');
      if (!cartRes.ok) return;
      const cart = await cartRes.json();
      if (!cart.items || cart.items.length === 0) return;

      const seedId = cart.items[0].product_id;
      const cartProductIds = new Set(cart.items.map(i => i.product_id));

      if (seedId === lastSeedId) return;
      lastSeedId = seedId;

      const recRes = await fetch(`${ENDPOINT}?product_id=${seedId}&limit=${LIMIT + 2}&intent=related`);
      if (!recRes.ok) return;
      const data = await recRes.json();
      const products = (data.products || []).filter(p => !cartProductIds.has(p.id)).slice(0, LIMIT);
      if (products.length === 0) return;

      const list = document.querySelector('[data-cart-upsell] .cart-drawer-upsell__list');
      if (!list) return;

      list.innerHTML = products.map(buildItem).join('');
    } catch (e) {
    } finally {
      isRunning = false;
    }
  }

  function bind() {
    document.addEventListener('drawer:opened', e => {
      if (e.detail?.drawerName === 'cart' || e.target?.id === 'CartDrawer') refresh();
    });
    document.addEventListener('cart:build', () => {
      lastSeedId = null;
      setTimeout(refresh, 350);
    });
    document.addEventListener('ajaxProduct:added', () => {
      lastSeedId = null;
      setTimeout(refresh, 350);
    });
    refresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
